export default __webpack_public_path__ + "static/media/logo.44f99087.png";